import { render, staticRenderFns } from "./UsersAdvertisers.vue?vue&type=template&id=647b0892"
import script from "./UsersAdvertisers.vue?vue&type=script&lang=ts"
export * from "./UsersAdvertisers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports